import { Divider, Link, Stack, Typography } from "@mui/material";
import { useFormContext } from "./BillingForm";
import { upperFirst } from "lodash";
import { planTypeMap } from "./constant";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";

export const PricePlanContainer = () => {
  const { planDetails, selectedPlan, updateSelectedPlan } = useFormContext();

  const subscription = selectedPlan?.plan;
  const plan = upperFirst(subscription?.type);
  const duration = planTypeMap[subscription?.type];
  const differenceWithYearly = subscription?.differenceWithYearly;
  const discount = Math.abs(subscription?.couponCodeDiscount);
  const couponCode = selectedPlan?.couponCode;

  const onHandleSwitch = () => {
    const updatedPlan = planDetails.find((item) => item.type === "annually");
    updateSelectedPlan(updatedPlan);
  };
  return (
    <Stack sx={{ position: "sticky", top: 20 }} gap={3}>
      <Stack border="1px solid rgba(0, 0, 0, 0.10)" borderRadius={"1rem"}>
        <Stack
          backgroundColor="#F2F2F3"
          direction={"row"}
          px={3}
          py={2}
          borderRadius={"1rem 1rem 0 0"}
          justifyContent={"space-between"}
        >
          <Typography fontWeight={600} color="#1F292E">
            {plan} Plan
          </Typography>
          <Link
            style={{ color: "#0A72C3", cursor: "pointer" }}
            fontWeight={600}
            href="/Billing"
          >
            Change
          </Link>
        </Stack>

        <Stack
          px={3}
          py={2}
          gap={1.5}
          borderRadius={"0 0 1rem 1rem"}
          backgroundColor="#FFF"
          overflow={"hidden"}
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            color="#415058"
          >
            <Typography fontWeight={500}>Subscription</Typography>
            <Typography fontWeight={500}>{duration} Month</Typography>
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            color="#415058"
          >
            <Typography fontWeight={500}>Pricing</Typography>
            <Typography fontWeight={500}>
              $ {subscription?.price} / Month
            </Typography>
          </Stack>
          {Number(discount) > 0 && (
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              color="#415058"
            >
              <Typography fontWeight={500}>Discount ({couponCode})</Typography>
              <Typography fontWeight={500}>- $ {discount}</Typography>
            </Stack>
          )}
          <Divider sx={{ borderColor: "#E0E2E4", borderBottomWidth: "2px" }} />
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography color="#1F292E" fontWeight={500}>
              Total
            </Typography>
            <Typography color="#1F292E" fontWeight={600} fontSize={"1.15rem"}>
              $ {subscription?.total}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      {differenceWithYearly > 0 && (
        <Stack
          direction={"row"}
          backgroundColor="rgba(10, 114, 195, 0.05)"
          borderRadius={".875rem"}
          border="1px solid #C4DDF1"
          p={2}
          gap={2}
        >
          <TipsAndUpdatesOutlinedIcon sx={{ color: "#0A72C3" }} />
          <Stack>
            <Typography color="#0A72C3">
              <span style={{ fontWeight: 600, color: "#053963" }}>
                Save ${differenceWithYearly} per year
              </span>{" "}
              with an annual subscription.{" "}
              <span
                style={{
                  fontWeight: 600,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={onHandleSwitch}
              >
                Switch to Yearly
              </span>
            </Typography>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
